<template>
    <div class="transactions-per-year" v-if="Array.isArray(customObject) && customObject.length">
        <h5>{{ title }}</h5>

        <div v-for="(item, index) in customObject" :key="index" class="accordion-item section-wrap payment-log-wrap">
            <div class="accordion-header" :class="activeIndex !== index ? 'accordion-inactive' : ''"
                @click="toggleAccordion(index)">
                <span v-if="activeIndex !== index">
                    Click to reveal payment transactions for year {{ item[0] }}
                </span>
                <span v-else>
                    Payment transactions for year {{ item[0] }}
                </span>
                <div v-if="activeIndex === index && Array.isArray(customObject) && (customObject.length > 0)"
                    class="download-container" @click.stop="exportBillingAndPurchases(index)">
                    <img src="../../../assets/images/download-square.svg" title="Download" alt="Download Icon">
                </div>
            </div>

            <div class="accordion-content" v-show="activeIndex === index">
                <table id="transactions">
                    <tbody>
                        <tr class="table-heading">
                            <th>Payment Date</th>
                            <th>Paid Amount</th>
                            <th>Event Type</th>
                        </tr>
                        <tr v-for="(transaction, tIndex) in Object.values(item[1]).flat()"
                            :key="transaction.created_at + '-' + tIndex">
                            <td>{{ getFormattedDate(transaction.created_at, "MMMM D, Y") }}</td>
                            <td>{{ profile.currency === 'USD' ? `$${transaction.amount_paid}` :
                                `${transaction.amount_paid}
                                ${profile.currency}` }}</td>
                            <td>{{ transaction.log_type }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>


        </div>
    </div>
</template>

<script>
import moment from 'moment';
import store from '../../../services/vuex';

export default {
    name: "CustomTable",
    props: {
        title: {
            type: String,
            required: true,
        },
        customObject: {
            type: [Array, Object],
            required: true,
        },
        profile: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            activeIndex: null,
        };
    },
    computed: {
        adminDetails: {
            get: function () {
                return this.$store.state.adminDetails;
            },
            set: function (value) {
                this.$store.commit("setAdminDetails", value);
            },
        },
    },
    mounted: function () {
        this.toggleAccordion(0);
    },
    methods: {
        toggleAccordion(index) {
            this.activeIndex = index;
        },
        getFormattedDate(date, format) {
            return moment(date, "YYYY-MM-DD hh:mm:ss").format(format);
        },
        exportBillingAndPurchases(index) {
            // Get the selected year's data
            const yearItem = this.customObject[index];
            if (!yearItem) {
                alert("No data found for this year.");
                return;
            }

            const year = yearItem[0];
            const transactions = Object.values(yearItem[1]).flat();

            if (!transactions.length) {
                alert(`No transactions found for ${year}.`);
                return;
            }

            // CSV header - all wrapped in quotes
            let csv = '"Payment Date","Paid Amount","Event Type"\n';

            // Helper function to safely quote CSV values
            const quote = (value) => `"${String(value).replace(/"/g, '""')}"`;

            // Build each CSV row
            transactions.forEach((transaction) => {
                const paymentDate = this.getFormattedDate(transaction.created_at, "MMMM D, Y");
                const amountPaid =
                    this.profile.currency === "USD"
                        ? `$${transaction.amount_paid}`
                        : `${transaction.amount_paid} ${this.profile.currency}`;
                const eventType = transaction.log_type;

                // Build and append the row (quoted and comma-separated)
                const row = [quote(paymentDate), quote(amountPaid), quote(eventType)];
                csv += row.join(",") + "\n";
            });

            // Trigger CSV download
            const anchor = document.createElement("a");
            anchor.href = "data:text/csv;charset=utf-8," + encodeURIComponent(csv);
            anchor.download = `billing_and_purchases_${year}.csv`;
            document.body.appendChild(anchor); // Ensure anchor exists in DOM for some browsers
            anchor.click();
            document.body.removeChild(anchor);
        }




    },
};
</script>
